import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'spark-shared-data-table-wrapper',
  templateUrl: './data-table-wrapper.component.html',
  styleUrls: ['./data-table-wrapper.component.scss']
})
export class SparkSharedDataTableWrapperComponent implements OnDestroy {
  @Input() title = '';
  @Input() downloading = false;

  @Output() downloadClicked = new EventEmitter<null>();

  private destroying$ = new Subject<null>();

  constructor() {}

  ngOnDestroy(): void {
    this.destroying$.next(null);
    this.destroying$.complete();
  }

  download() {
    this.downloadClicked.emit(null);
  }
}
